export const TOAST_COOKIE_NAME = 'toast';
export const TOAST_MESSAGE_SEPARATOR = '::';

export type ToastCookieContent = {
  success: boolean;
  context: string;
  message: string;
  error: string;
  timeout: number;
} | null;

export function useToastCookie(): Ref<ToastCookieContent> {
  return useCookie<ToastCookieContent>(TOAST_COOKIE_NAME);
}
